export default "__VITE_ASSET__4oYBAmMl__"